import { FC } from 'react';

import { Box, Flex, Heading, Text } from '@rover/kibble/core';
import { Badge } from '@rover/kibble/official-patterns/Badge';

import { BRIGHT_HORIZONS_CREDITS_DONT_APPLY } from '../../../callouts/CalloutBadge/CalloutBadge.constants';

import usePriceDisplayInfo, { PriceDisplayProps } from './usePriceDisplayInfo';

const LegacyPriceColumn: FC<PriceDisplayProps> = (props) => {
  const { formattedPrice, beforePriceText, afterPriceText, showBrightHorizonsCalloutBadge } =
    usePriceDisplayInfo(props);

  return (
    <Flex
      flexDirection="column"
      alignItems="flex-end"
      alignSelf="stretch"
      justifyContent="flex-start"
      width="auto"
      maxWidth="100%"
    >
      {showBrightHorizonsCalloutBadge && (
        <Box marginBottom="1x" textAlign="right" maxWidth="150px">
          <Badge
            {...BRIGHT_HORIZONS_CREDITS_DONT_APPLY()}
            boxProps={{
              sx: {
                boxDecorationBreak: 'clone',
              },
            }}
          />
        </Box>
      )}
      <Flex flexDirection="column" alignItems="flex-end" gap="0.5x">
        {beforePriceText && (
          <Text size="100" textColor="tertiary">
            {beforePriceText}
          </Text>
        )}
        <Heading size="400" webProps={{ responsive: false, as: 'div' }} mb="0x" textColor="success">
          {formattedPrice}
        </Heading>
        <Text
          size="100"
          textColor="tertiary"
          sx={{ whiteSpace: 'nowrap' }}
          rxnProps={{ numberOfLines: 1 }}
        >
          {afterPriceText}
        </Text>
      </Flex>
    </Flex>
  );
};

export default LegacyPriceColumn;
